import React from 'react';

interface HoldingRow {
  symbol: string;
  equity_pct: number;
  net_options_pct: number;
  net_weight_pct: number;
  sector: string;
  beta: number | null;
  n_equity: number;
  n_options: number;
}

interface Props {
  rows: HoldingRow[];
}

const fmt = (n: number | null | undefined, digits = 2): string => {
  if (n == null || !Number.isFinite(n)) return '—';
  if (Math.abs(n) < 0.005) return '—';
  const sign = n > 0 ? '+' : '';
  return sign + n.toFixed(digits);
};

const HoldingsTable: React.FC<Props> = ({ rows }) => {
  if (!rows || rows.length === 0) return null;

  return (
    <section className="holdings-table-section">
      <h3>Consolidated by symbol (% of NAV)</h3>
      <div className="holdings-table-wrap">
        <table className="holdings-table">
          <thead>
            <tr>
              <th>Symbol</th>
              <th className="num">Equity</th>
              <th className="num">Net options</th>
              <th className="num">Net weight</th>
              <th>Sector</th>
              <th className="num">Beta</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.symbol}>
                <td className="sym">{r.symbol}</td>
                <td className="num">{r.equity_pct > 0.005 ? r.equity_pct.toFixed(2) : '—'}</td>
                <td className={`num ${r.net_options_pct < 0 ? 'neg' : r.net_options_pct > 0 ? 'pos' : ''}`}>
                  {fmt(r.net_options_pct)}
                </td>
                <td className="num bold">{r.net_weight_pct.toFixed(2)}</td>
                <td>{r.sector}</td>
                <td className="num">{r.beta != null ? r.beta.toFixed(2) : '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default HoldingsTable;
